export default "__VITE_ASSET__KZ$Xl_kZ__"